/* ============
 * Mutation types for the Units module
 * ============
 *
 * The mutation types that are available
 * on the Units module.
 */

export const LOAD = 'LOAD';
export const LOAD_RELATED = 'LOAD_RELATED';
export const SET_CURRENT = 'SET_CURRENT';
export const ADD_FAVOURITE = 'ADD_FAVOURITE';
export const REMOVE_FAVOURITE = 'REMOVE_FAVOURITE';
export const SET_FAVOURITES = 'SET_FAVOURITES';
export const SET_CROP = 'setCrop';

export default {
  LOAD,
  LOAD_RELATED,
  SET_CURRENT,
  ADD_FAVOURITE,
  REMOVE_FAVOURITE,
  SET_FAVOURITES,
  SET_CROP,
};
